import { Injectable } from '@angular/core';
import { InviteApiController } from '../api-controllers/invite.api-controller';
import { InviteModel } from '../../../../../../common/dist/angular/models/invite.model';
import { LoggingService } from '../../../../modules/src/lib/core/services/logging.service';

@Injectable()
export class InviteManager {
  public invitationsForCurrentUser?: InviteModel[] = undefined;

  constructor(
    protected inviteApiController: InviteApiController,
    private readonly loggingService: LoggingService,
  ) {
  }

  async initForCurrentUser() {
    if (this.invitationsForCurrentUser === undefined) {
      try {
        this.invitationsForCurrentUser = await this.inviteApiController.listForUser();
        this.loggingService.debug('Invites retrieved for current user', this.invitationsForCurrentUser);
      } catch (error) {
        this.loggingService.error('Error retrieving the invites for the current user.', error);
      }
    }

    return this.invitationsForCurrentUser;
  }

  async getForCurrentUser(): Promise<InviteModel[]> {
    if (this.invitationsForCurrentUser === undefined) {
      await this.initForCurrentUser();
    }

    return this.invitationsForCurrentUser;
  }

  async refreshForCurrentUser(): Promise<InviteModel[]> {
    if (this.invitationsForCurrentUser === undefined) {
      await this.initForCurrentUser();
    }

    return this.invitationsForCurrentUser;
  }
}
